import { render, staticRenderFns } from "./wishlistItem.vue?vue&type=template&id=4cbf88e8"
import script from "./wishlistItem.vue?vue&type=script&lang=js"
export * from "./wishlistItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports